/*
  uploadData(stage:string, filename:string, data:object)

  downloadData(stage:string)

  deleteData(stage:string, filename:string)

  callFetch(method:string, body:object)
*/


class StorageInterface {
  constructor(devAddress, prodAddress, errMessage){
    this.devAddress = devAddress;
    this.prodAddress = prodAddress;
    this.errMessage = errMessage;
  }

  // Helper method to determine current environment
  getCurrentEnvironment() {
    // Allow manual override via environment variable (useful for testing)
    if (process.env.REACT_APP_FORCE_ENV) {
      const forcedEnv = process.env.REACT_APP_FORCE_ENV.toLowerCase();
      if (forcedEnv === 'prod' || forcedEnv === 'production') {
        return 'prod';
      } else if (forcedEnv === 'dev' || forcedEnv === 'development') {
        return 'dev';
      }
    }
    
    // Check if we're in production based on various indicators
    const isProduction = 
      process.env.NODE_ENV === 'production' ||
      process.env.REACT_APP_ENV === 'production' ||
      window.location.hostname === 'essentialsafety.nyc' ||
      window.location.hostname === 'www.essentialsafety.nyc';
    
    return isProduction ? 'prod' : 'dev';
  }

  callFetch(stage, method, body=null, queryParams=null) {
    let config = {
      method: method,
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }

    // If stage is not explicitly provided, auto-detect
    const effectiveStage = stage || this.getCurrentEnvironment();
    let fetchAddress = effectiveStage === "dev" ? this.devAddress : this.prodAddress;
    
    // Add query params to URL if provided
    if (queryParams) {
      const params = new URLSearchParams(queryParams);
      fetchAddress += '?' + params.toString();
    }
    
    // Log which environment we're using (helpful for debugging)
    if (process.env.NODE_ENV !== 'production') {
      console.log(`[StorageInterface] Using ${effectiveStage} environment: ${fetchAddress}`);
    }

    if (body) {
      config.body = JSON.stringify(body);
    }

    return fetch(fetchAddress, config)
    .then(response => response.json())
    .then(response => {
      // Handle Lambda proxy integration response format
      if (response.statusCode) {
        // Lambda response format: {statusCode: 200, headers: {...}, body: "..."}
        if (response.statusCode !== 200) {
          console.error('[StorageInterface] Error response:', response);
          return this.errMessage;
        }

        if (response.body) {
            const parsedBody = JSON.parse(response.body);
            // New format has 'data' at top level of parsed body
            return parsedBody.data || parsedBody;
        }
      } else if (response.success && response.data) {
        // Direct response format from new Lambda (if proxy integration returns body directly)
        return response.data;
      } else {
        // Unknown format or error
        console.error('[StorageInterface] Unexpected response format:', response);
        return this.errMessage;
      }
    })
    .catch(error => {
      console.error('[StorageInterface] Fetch error:', error);
      return this.errMessage;
    });
  }


  async deleteData(stage = null, filename) {
    const effectiveStage = stage || this.getCurrentEnvironment();
    let response = await this.callFetch(effectiveStage, 'DELETE', { filename }, null);
    return response;
  }


  async downloadData(stage = null, folder = 'calendarData/') {
    const effectiveStage = stage || this.getCurrentEnvironment();
    let response = await this.callFetch(effectiveStage, 'GET', null, { folder });
    return response;
  }


  async uploadData(stage = null, filename, data) {
    const effectiveStage = stage || this.getCurrentEnvironment();
    let response = await this.callFetch(effectiveStage, "POST", { filename, file: data }, null);
    return response;
  }
}


const devAddress = "https://ikgv00tqnh.execute-api.us-east-1.amazonaws.com/beta/storageinterface/dev";
const prodAddress = "https://ikgv00tqnh.execute-api.us-east-1.amazonaws.com/beta/storageinterface/prod";
const errMessage = {
  line1: "Sorry an error occured while accessing storage data",
  line2: "Please try again later or send us an email at kimsha@essentialsafety.nyc"
};


let storageInterface = new StorageInterface(
  devAddress,
  prodAddress,
  errMessage
);




export default storageInterface;